import React from 'react';
import { useTranslation } from 'react-i18next';
import { trackEvent, EVENTS } from '../../analytics/events';

const WhatsAppButton = () => {
  const { t } = useTranslation();
  const whatsappMessage = encodeURIComponent(t('whatsapp.message'));

  const handleClick = () => {
    trackEvent(EVENTS.WHATSAPP_CTA_CLICK, { placement: 'global' });
  };

  return (
    <a
      id="robbu-whatsapp-button"
      target="_blank"
      rel="noreferrer"
      href={`https://api.whatsapp.com/send?phone=555135572998&text=${whatsappMessage}`}
      style={{ zIndex: 10 }}
      onClick={handleClick}
    >
      <div className="rwb-tooltip" style={{ backgroundColor: 'whitesmoke' }}>
        {t('whatsapp.contact')}
      </div>
      <img
        src="https://cdn.positus.global/production/resources/robbu/whatsapp-button/whatsapp-icon.svg"
        alt="WhatsApp"
      />
    </a>
  );
};

export default WhatsAppButton;
